<template>


  <div class="container-fluid">



      <div id="hero" class="section-hero">




        <nav class="navbar navbar-expand-lg navbar-light py-4">
          <div class="container">
            <a class="navbar-brand" href="#">
              <img id="logo-top" class="img-fluid" src="static/creditu_logo.svg" alt="">
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#nav09" aria-controls="nav09" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="nav09">
              <ul class="navbar-nav mt-3 mt-lg-0 mb-3 mb-lg-0 ms-lg-auto me-4">
                

                            <li class="nav-item me-4 active"><a class="nav-link" href="https://creditu.pl/">
                            Strona główna</a></li>
                                                                                                                        
                            <li class="nav-item me-4 "><a class="nav-link" href="https://creditu.pl/o-creditu/">
                            O CrediTu</a></li>
                                                                                                                        
                            <li class="nav-item me-4 "><a class="nav-link" href="https://creditu.pl/jak-to-dziala/">
                            Jak to działa?</a></li>
                                                                                                                        
                            <li class="nav-item me-4 "><a class="nav-link" href="https://creditu.pl/pytania-i-odpowiedzi/">
                            Pytania</a></li>
                                                                                                                        
                            <li class="nav-item me-4 "><a class="nav-link" href="https://creditu.pl/kontakt/">
                            Kontakt</a></li>
              </ul>






              <div>
                <!--
                  <a class="btn btn-outline-secondary me-2" href="#">Sign In</a>
                -->  


                  <a v-if="loggedIn && !isClientV"  class="btn btn-primary" href="#" @click="gotoclient">Strefa klienta</a>
                  <a v-if="!loggedIn" v-show="!isLoginV" class="btn btn-primary" href="#" data-bs-toggle="modal" data-bs-target="#loginDialog">Zaloguj się</a>
                  <a v-if="loggedIn" class="btn btn-primary" href="#" @click="doLogout">Wyloguj</a>



                  
              </div>
            </div>
          </div>
        </nav>











      <LPopup/>
      <ForgotPassword/>


      <loading-screen :is-loading="isLoading"></loading-screen>





      <router-view :form="form" ></router-view>






    </div>





            
      <footer class="py-5 dark">
          <div class="container">
              <div class="row">
                      <div class="col-12 col-md-6 col-lg-auto me-lg-4 d-flex flex-column contact-list  my-3">
                          <img class="logo" src="static/creditu-inverted.svg"/>
                      </div>
                                  <div class="col-12 col-md-6 col-lg-auto me-lg-4 d-flex flex-column contact-list  my-3">
                                                                                                      <div class="contact-list-item d-flex align-items-stretch mb-2">
                                                                                  <img class="icon me-3" src="static/ikona-telefon.svg" />

                                                                                  <div class="d-flex align-items-center">22 121 86 79</div>
                                                                             
                                          </div>
                                                                          <div class="contact-list-item d-flex align-items-stretch mb-2">
                                                                                  <img class="icon me-3" src="static/ikona-at.svg" />
                                                                                                                      <div class="d-flex align-items-center"><a href="mailto:kontakt@creditu.pl">
                                              kontakt@creditu.pl                                        </a></div>
                                                                             
                                          </div>
                                                                          <div class="contact-list-item d-flex align-items-stretch mb-2">
                                                                                  <img class="icon me-3" src="static/ikona-zegar.svg" />
                                                                                                                      <div class="d-flex align-items-center">Biuro czynne: <br/> pn-pt: 8:00 - 16:00</div>
                                                                             
                                          </div>
                                </div>


                              <div class="col-12 col-md-6 col-lg-auto d-flex flex-column menu-creditu my-3 me-lg-4">        
                                  <h4>CrediTu</h4>
                                                                                                      <div>
                                                                                                                                                                                                                                                      
                                                                      <a href="https://creditu.pl/">
                                                                          Strona główna                                                                </a>
                                                                                                       
                                                                                          
                                                                                  
                                          </div>               
                                                                          <div>
                                                                                                                                                                                                                                                      
                                                                      <a href="https://creditu.pl/jak-to-dziala/">
                                                                          Jak to działa?                                                                </a>
                                                                                                       
                                                                                          
                                                                                  
                                          </div>               
                                                                          <div>
                                                                                                                                                                                                                                                      
                                                                      <a href="https://creditu.pl/pytania-i-odpowiedzi/">
                                                                          Pytania i odpowiedzi                                                                </a>
                                                                                                       
                                                                                          
                                                                                  
                                          </div>               
                                                                          <div>
                                                                                                                                                                                                                              
                                                      <a href="https://wniosek.creditu.pl">
                                                              Zaloguj się                                                    </a>                                            
                                                                                                                              
                                          </div>               
                                                                                          </div>

                              
                              <div class="col-12 col-md-6 col-lg-auto d-flex flex-column menu-documents my-3 me-lg-4">        
                                  <h4>Dokumenty</h4>
                                                                                                      <div>
                                                                                                                                                                                                                                                                  
                                                                      <a href="static/wzor_umowy.pdf" target="_blank">
                                                                          Wzór umowy pożyczki                                                                </a>
                                                                                                       
                                                                                                  
                                                                                      
                                          </div>



                                          <div>
                                                                                                                                                                                                                                                                  
                                                                      <a href="static/klauzula_informacyjna.pdf" target="_blank">
                                                                          Klauzula informacyjna                                                                </a>
                                                                                                       
                                                                                                  
                                                                                      
                                          </div>




                                          <div>
                                                                                                                                                                                                                                                                  
                                                                      <a href="static/polityka_cookies.pdf" target="_blank">
                                                                          Polityka cookies                                                                </a>
                                                                                                       
                                                                                                  
                                                                                      
                                          </div>
                                                                          <div>
                                                                                                                                                                                                                                                                  
                                                                      <a href="static/regulamin.pdf" target="_blank">
                                                                          Regulamin świadczenia usług                                                                </a>
                                                                                                       
                                                                                                  
                                                                                      
                                          </div>
                                                                          <div>
                                                                                                                                                                                                                                                                  
                                                                      <a href="https://creditu.pl/archiwum-plikow/">
                                                                          Archiwum plików                                                                </a>
                                                                                                       
                                                                                                  
                                                                                      
                                          </div>
                                                                          <div>
                                                                                                                                                                                                                                                                  
                                                                      <a href="https://creditu.pl/lista-partnerow/">
                                                                          Lista partnerów                                                                </a>
                                                                                                       
                                                                                                  
                                                                                      
                                          </div>
                                </div>                        
                              







                      <div class="col-12 legal my-4">
                        <p>Informacje zawarte na stronie są na bieżąco aktualizowane i należą do FinGO Capital S.A. Spółka zastrzega sobie prawo zmiany zawartości strony internetowej w każdym czasie i w dowolnym zakresie bez uprzedniego zawiadomienia.</p>
                        <p><strong>Informacje dotyczące pożyczkodawcy:</strong></p>
                        <p>Pyczkodawcą jest FinGO Capital S.A. z siedzibą w Warszawie, ul. Augustyna Kordeckiego 43/2, 04-327 Warszawa, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy m.st. Warszawy w Warszawie, XIII Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem 0000663247, NIP: 1132930245, REGON: 366553244, posiadającą kapitał zakładowy w wysokości 12 300 000,00 zł. Numer wpisu w rejestrze instytucji pożyczkowych prowadzonego przez Komisję Nadzoru Finansowego: RIP000090, działamy w oparciu o przepisy polskiego prawa określone w szczególności w Kodeksie cywilnym oraz Ustawie o kredycie konsumenckim.</p>
                        <p><strong>Reprezentatywny przykład pożyczki:</strong></p>
                        <p>Przyznanie pożyczki zależy od wyniku oceny zdolności kredytowej wnioskodawcy. Reprezentatywny przykład dla pożyczki udzielanej za pośrednictwem strony internetowej https://www.creditu.pl: Rzeczywista Roczna Stopa Oprocentowania (RRSO) to {{getConf('sample_rrso')}}% przy założeniach: całkowita kwota pożyczki {{getConf('sample_amount')}} zł; całkowita kwota do zapłaty {{getConf('sample_total')}} zł; oprocentowanie stałe w skali roku {{getConf('nbp_interest_rate')}}%; całkowity koszt pożyczki {{getConf('sample_cost')}} zł (prowizja {{getConf('sample_fee_plus_service')}} zł, odsetki {{getConf('sample_interest')}} zł); umowa na 30 dni. Stan na {{getConf('sample_valid_from')}} r. Maksymalna wysokość pożyczki przez internet to 3000 zł. Weryfikujemy Twój rachunek bankowy na podstawie unijnej dyrektywy PSD2, za pomocą systemu TransactionLink.</p>
                        <p><strong>Ochrona danych osobowych:</strong></p>
                        <p>Administratorem danych osobowych jest FinGO Capital S.A. z siedzibą w Warszawie, ul. Augustyna Kordeckiego 43/2, 04-327 Warszawa. Wszelkie informacje na temat zasad przetwarzania danych osobowych, celów, w jakich są przetwarzane, podstaw prawnych przetwarzania, kategoriach odbiorców danych osobowych, okresie przetwarzania danych, konieczności lub dobrowolności podania danych osobowych i konsekwencjach ich niepodania, zautomatyzowanym podejmowaniu decyzji i przysługujących Ci uprawnieniach znaleźć możesz w naszej klauzuli informacyjnej.</p>
                        <p><strong>Pozostałe:</strong></p>
                        <p>Podmiotem właściwym do pozasądowego rozstrzygania sporu wynikającego z umowy zawartej pomiędzy konsumentem a FinGO Capital S.A. jest Rzecznik Finansowy. Kontakt do Rzecznika Finansowego oraz szczegółowe informacje dotyczące postępowania dostępne są na stronie internetowej www.rf.gov.pl. W celu rozstrzygnięcia sporu pomiędzy FinGO Capital S.A. a konsumentem, istnieje także możliwość skorzystania z platformy internetowej ODR, dostępnej <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&amp;lng=PL">TUTAJ</a>. Platforma ODR ułatwia niezależne, bezstronne, przejrzyste, skuteczne, szybkie i sprawiedliwe pozasądowe rozstrzyganie przez internet sporów między konsumentami i przedsiębiorcami.</p>
                      </div>















                                                      
                  </div>

          </div> 
      </footer>



  </div>
</template>

<script>


  import Loader from "./components/Loader";

  import LPopup from "./components/LoginPopup";

  import ForgotPassword from './components/ForgotPasssword';

export default {
  name: 'FingoPage',

    components: {
      'loading-screen': Loader,
      LPopup,
      ForgotPassword
    },


  computed: {
//console.log('is client')
//console.log(this.$router.currentRoute.path)
  },


  data() {
    return {


      form: {},


      isLoading: false,
      isClientV: false,
      isLoginV: false,
      loggedIn: false,
      isOpen: false,

      // registered by affiliate - otp login
      isRegisterLink: false,

      // email z leada OTP (znormalizowany) - existCheck porownuje z wpisanym
      // emailem; zmiana emaila w trybie OTP nie moze ominac lookupu /existsapi
      // (null = sesja bez OTP, '' = lead bez emaila)
      otpEmail: null,

      headFoot: true

    }
  },


  watch:{
    $route (to){


      this.isClientV = to.path === '/client';
      this.isLoginV = to.path === '/login';

    }
  },



  methods: {

    // Odtworzenie kwoty leada (flow OTP, klient niezalogowany): kwota wniosku
    // od brokera moze byc w odpowiedzi /application/otp pod rozna nazwa pola
    // (brak dokumentacji GATEWAY), wiec sondujemy kandydatow. Trafiona kwota
    // jest przyciagana do siatki kalkulatora (loan_params) i ustawiana przez
    // setValues — user widzi kwote ze swojego wniosku u brokera i moze ja
    // swiadomie zmienic. Log konczacy pozwala zweryfikowac na produkcyjnych
    // .jsonl, ktore pole realnie przychodzi (albo ze zadne — wtedy kalkulator
    // zostaje na domyslnej, jak dotychczas).
    prefillLeadAmount(ob){

      var fields = ['requested_amount', 'loan_amount', 'net_amount', 'amount'],
          amt = NaN,
          src = null,
          i;

      for (i = 0; i < fields.length; i++) {

        if (ob.hasOwnProperty(fields[i]) && parseFloat(ob[fields[i]]) > 0) {

          amt = parseFloat(ob[fields[i]]);
          src = fields[i];
          break;
        }
      }

      if (!(amt > 0)) {

        this.log('- OTP REGISTER - brak kwoty leada w odpowiedzi OTP, kalkulator z domyslna');
        return;
      }


      // tenor z leada o ile istnieje w tabeli parametrow, inaczej domyslny 30d
      var t = String(parseInt(ob.requested_time) || 30),
          s = 'd';

      if (!this.loan_params.hasOwnProperty(t + s)) {

        t = '30';
      }

      if (!this.loan_params.hasOwnProperty(t + s)) {

        this.log('- OTP REGISTER - kwota leada ' + amt + ' (' + src + ') bez tabeli parametrow, kalkulator z domyslna');
        return;
      }


      // przyciagniecie do najblizszej kwoty dostepnej w kalkulatorze
      var grid = Object.keys(this.loan_params[t + s]).map(Number),
          snapped = grid.reduce((best, g) => Math.abs(g - amt) < Math.abs(best - amt) ? g : best, grid[0]);

      this.setValues(snapped, t, s);

      this.log('- OTP REGISTER - kwota leada ' + amt + ' (' + src + ') -> kalkulator ' + snapped);
    },


    doLogout(notoast=false){
      this.isOpen = !this.isOpen;
      // remove user from local storage to log user out
      localStorage.removeItem('user');

      this.loggedIn = false;


      this.$route.path != '/'
        && this.goToMainPage();


      // reset form
      this.form = new Object();


      this.echo('logout');


      !notoast
        && this.toast('Wylogowano!');
    },



    reLogin() {


      console.log('login reloaded user');

      let user = JSON.parse(localStorage.getItem('user'));

      this.post( '/client/login', {

          client_login: user.E1,
          client_password: user.E2
        })
        .then(response => {

       //   page.isLoading = false;

          if (!!response.data) {

            response.data.E1 = user.E1;
            response.data.E2 = user.E2;

            // rerset state
            this.loggedIn = response.data;

            localStorage.setItem('user', JSON.stringify(response.data));

            this.echo('login_reloaded', response.data);
          }

        })
        .catch(error => {

          this.echo('login_reload_error');
        });

    },




    gotoclient() {

        this.$router.push({path: '/client'}).then( success => {return success});
    },


    gotologin() {

        this.$router.push({path: '/login'});
    },



    gotothanku() {

        this.$router.push({path: '/thankyou'});
    },


    goToMainPage() {

        this.$router.push({path: '/'});
    },


    gotokontox() {


        this.$router.push({path: 'kontox'});

    },




    foobar() {


        console.log('this is is roots 1 page')
    }

  },


  created() {



      this.log( 'form enter with URI  ' + window.location.href );




      let dt = localStorage.getItem('user');


      this.listen('logged_in', (data) => {
          this.loggedIn = data;
      });

      this.listen('next_step_fail', () => {
          /*console.log("elo");*/
          this.echo('ForgotPasswordModal',"stepFail");
      });

/*    this.listen('logged_in', (data) => {
      this.loggedIn = data;
    });*/


    this.listen('login_reload', () => {
      this.reLogin();
    });



    this.get( '/session' )
    .then(response => {

      if (!!response.data) {
        let ok = !(response.data.IS_ERROR | 0);


        if ( ok && dt ) {

          this.loggedIn = JSON.parse(dt);
        }
      }
      else {

        this.doLogout(true);
      }
    })
    .catch(error => {

      !!dt && this.doLogout(true);

      // Error
      if (error.response) {
         //console.log(error.response);
      }
    });



    if (this.$route.path == '/pdf') {

      this.headFoot = false;
    }






  },


  mounted() {




    let uriParams = window.location.href.split('?'),

        uriToken = pName => {

          let url_array = window.location.href.split('\/').join().split('?').join().split( pName + '='),
              tmp_token_before_regex = url_array[1],
              tmp_token = tmp_token_before_regex.replace(/[#,]/g, ""),
              token = tmp_token_before_regex.split('#');

          // clean param
          let params = new URLSearchParams(location.search);
          params.delete( pName );
          history.replaceState(null, '', '?' + params + location.hash);


          return token[0];
        },

        // alternative version - to be tested
        getQueryParam = param => {
          const urlParams = new URLSearchParams(window.location.search);
          return urlParams.get(param);
        };




    if (uriParams.length > 1) {



      if (/login/.test(uriParams[1]) ) {

        this.echo('login_dialog');
      }



      if (/code=/.test(uriParams[1]) ) {

          this.echo('ForgotPasswordModal', uriToken('code'));
      }



      if (/utm_source=/.test(uriParams[1]) ) {


        let aff = JSON.stringify({
            source: getQueryParam('utm_source'),
            identity: getQueryParam('utm_id')
          });


        localStorage.setItem('affiliate', aff);        
      }





       // register by link
       if (/register=/.test(uriParams[1])) {


          let regToken = uriToken('register');



          if (!regToken) {


            this.log( '- OTP REGISTER - no token - skip' );

          }
          else {


            this.log( '- OTP REGISTER - ' + regToken );


            // start heart beat
            //window.heartBeat = setInterval( this.pulse, 15000);



            this.isLoading = true;

            this.get('/application/otp/' + regToken )

              .then(response => {

                this.isLoading = false;


                if (!!response.data) {


                  this.isRegisterLink = true;

                  this.otpEmail = response.data.hasOwnProperty('client_email')
                    ? String(response.data.client_email).trim().toLowerCase()
                    : '';


                  let ob = response.data,
                      has,
                      f = this.getConf('fields_otp_mapping');


                  // set little delay to give some render time.
                  setTimeout( () => {

                    // fill up form
                    Object.keys(f).map( k => {


                        has = ob.hasOwnProperty( f[k] ) ? ob[ f[k] ] : f[k];


                        //cascade fields and parse

                        // cut the whitespaces / enters etc.. from portal app
                        if (/client_name|client_surname|client_email/.test(k)) {


                          this.$set(this.form, k, String(has).trim());
                        }
                        else if (/client_employment_income/.test(k)){


//console.log('income set to ' + (isNaN(parseInt(has)) ? 'NANNN' : 'ok') + ' ' + (has | 0));
                         
                          this.$set(this.form, k, parseInt(has | 0));
                                           
                        }
                        else if (/client_address[1-2]_building/.test(k)){


                          // limited by validation to 10 chars
                          if (String(has).length > 10) {

                            this.$set(this.form, k, String(has).substr(0,10));
                          }
                          else {                           

                            this.$set(this.form, k, has);
                          }                                           
                        }

                        else if (/client_employment_type/.test(k)){

                          // test if valid employment value provided
                          if ([0,2,3,4,5,6,8,9,11,12,14,7,13,1].indexOf( (has | 0) ) > -1 ) {

                            this.$set(this.form, k, parseInt(has));
                          }                        
                          else {

                            // default employment type - 4 equals other
                            this.$set(this.form, k, 4);
                          }
                        }

                        // deault
                        else {

                          this.$set(this.form, k, has);
                        }



                      });


                      // odtworzenie kwoty wniosku leada w kalkulatorze — flow OTP
                      // jest niezalogowany, wiec /client/loans nie jest dostepne
                      this.prefillLeadAmount(ob);

                  }, 500);



                }

              })
              .catch(error => {

                this.isLoading = false;

                this.log( '- OTP REGISTER - get otp data fail.' );

                //console.log('Network error on otp endpoint', error);
              });

          }

       }









    }




    this.isClientV = this.$route.path === '/client';



    /*setTimeout(() => {
      this.isLoading = false
    }, 5000)*/



    /*
  .header::before {
    content: " ";
    display: block;
    width: 475px;
    height: 475px;
    background-color: #f79949;
    position: absolute;
    top: -160px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    border-radius: 50%;
  }


    */
    },



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>



// WEBPACK FOOTER //
// src/FingoPage.vue